import { jsxs, jsx } from "react/jsx-runtime";
import { O as ObjectProperties } from "../../../../index-5e4e4f4b.js";
import { c as classNames } from "../../../../index-e71f83b5.js";
import React__default, { useState, useCallback, useMemo } from "react";
import { P as PropTypes, e as canUseDOM, c as targetPropType, T as TransitionTimeouts, k as keyCodes, f as focusableElements, g as getTarget, h as getOriginalBodyPadding, i as conditionallyUpdateScrollbar, m as mapToCssModules, s as setScrollbarWidth, o as omit } from "../../../../utils-f8d1c624.js";
import ReactDOM__default from "react-dom";
import { F as Fade } from "../../../../Fade-1a465599.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import { useInsightsImpression } from "../../../../hooks/useInsights/useInsightsImpression.js";
import { analyticsEventForImpression } from "../../../../hooks/useInsights/utils.js";
import { useWindowSize } from "../../../../hooks/useWindowSize/useWindowSize.js";
import i18n from "../../../../i18n/index.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccessTime.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccessTimeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccountCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccountCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Add.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddLocation.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddLocationFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettings.js";
import "../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettingsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Analytics.js";
import "../../../../styles/assets/images/icons/material/designSystem/AnalyticsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Apartment.js";
import "../../../../styles/assets/images/icons/material/designSystem/Apps.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowBack.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleLeftFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleRightFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDownward.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDropDown.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDropUp.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowForward.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowUpward.js";
import "../../../../styles/assets/images/icons/material/designSystem/Bolt.js";
import "../../../../styles/assets/images/icons/material/designSystem/BoltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/BugReport.js";
import "../../../../styles/assets/images/icons/material/designSystem/Business.js";
import "../../../../styles/assets/images/icons/material/designSystem/Calculate.js";
import "../../../../styles/assets/images/icons/material/designSystem/CalculateFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/CalendarTodayFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Cancel.js";
import "../../../../styles/assets/images/icons/material/designSystem/CancelFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/CheckCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/CheckCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ChevronLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/ChevronRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/Circle.js";
import "../../../../styles/assets/images/icons/material/designSystem/CircleFilled.js";
import { ReactComponent as ForwardRef } from "../../../../styles/assets/images/icons/material/designSystem/Close.js";
import "../../../../styles/assets/images/icons/material/designSystem/CoPresent.js";
import "../../../../styles/assets/images/icons/material/designSystem/CoPresentFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumber.js";
import "../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumberFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContactSupport.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContactSupportFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContentCopy.js";
import "../../../../styles/assets/images/icons/material/designSystem/CopyAll.js";
import "../../../../styles/assets/images/icons/material/designSystem/CreditCard.js";
import "../../../../styles/assets/images/icons/material/designSystem/CreditCardFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Dashboard.js";
import "../../../../styles/assets/images/icons/material/designSystem/DashboardFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Delete.js";
import "../../../../styles/assets/images/icons/material/designSystem/DeleteFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsCar.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsCarFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DisabledByDefault.js";
import "../../../../styles/assets/images/icons/material/designSystem/DisabledByDefaultFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DoNotDisturb.js";
import "../../../../styles/assets/images/icons/material/designSystem/Edit.js";
import "../../../../styles/assets/images/icons/material/designSystem/EditFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ElectricCar.js";
import "../../../../styles/assets/images/icons/material/designSystem/ElectricCarFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Error.js";
import "../../../../styles/assets/images/icons/material/designSystem/ErrorFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/EventFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandContent.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandLess.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandMore.js";
import "../../../../styles/assets/images/icons/material/designSystem/Favorite.js";
import "../../../../styles/assets/images/icons/material/designSystem/FavoriteFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FileCopy.js";
import "../../../../styles/assets/images/icons/material/designSystem/FileCopyFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FilterAltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FirstPage.js";
import "../../../../styles/assets/images/icons/material/designSystem/Forward.js";
import "../../../../styles/assets/images/icons/material/designSystem/GarageHome.js";
import "../../../../styles/assets/images/icons/material/designSystem/GarageHomeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/GridView.js";
import "../../../../styles/assets/images/icons/material/designSystem/Group.js";
import "../../../../styles/assets/images/icons/material/designSystem/GroupFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Help.js";
import "../../../../styles/assets/images/icons/material/designSystem/HelpFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/HideSource.js";
import "../../../../styles/assets/images/icons/material/designSystem/Home.js";
import "../../../../styles/assets/images/icons/material/designSystem/HomeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Info.js";
import "../../../../styles/assets/images/icons/material/designSystem/InfoFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/IosShare.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowDown.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowUp.js";
import "../../../../styles/assets/images/icons/material/designSystem/LastPage.js";
import "../../../../styles/assets/images/icons/material/designSystem/Link.js";
import "../../../../styles/assets/images/icons/material/designSystem/ListAlt.js";
import "../../../../styles/assets/images/icons/material/designSystem/ListAltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/LocalLibraryFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/LocationOn.js";
import "../../../../styles/assets/images/icons/material/designSystem/LocationOnFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/LockOpen.js";
import "../../../../styles/assets/images/icons/material/designSystem/LockReset.js";
import "../../../../styles/assets/images/icons/material/designSystem/Logout.js";
import "../../../../styles/assets/images/icons/material/designSystem/Loop.js";
import "../../../../styles/assets/images/icons/material/designSystem/Mail.js";
import "../../../../styles/assets/images/icons/material/designSystem/MailFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Menu.js";
import "../../../../styles/assets/images/icons/material/designSystem/MonitorHeart.js";
import "../../../../styles/assets/images/icons/material/designSystem/MonitorHeartFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/MoreHoriz.js";
import "../../../../styles/assets/images/icons/material/designSystem/MoreVert.js";
import "../../../../styles/assets/images/icons/material/designSystem/NetworkCheck.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationImportant.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationImportantFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Notifications.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsActive.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsActiveFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsOff.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsOffFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Paid.js";
import "../../../../styles/assets/images/icons/material/designSystem/PaidFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Pending.js";
import "../../../../styles/assets/images/icons/material/designSystem/Percent.js";
import "../../../../styles/assets/images/icons/material/designSystem/Person.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonAdd.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonAddFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PhoneDisabled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PhoneDisabledFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PointOfSale.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceChange.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceChangeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceCheck.js";
import "../../../../styles/assets/images/icons/material/designSystem/Publish.js";
import "../../../../styles/assets/images/icons/material/designSystem/PublishFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PushPin.js";
import "../../../../styles/assets/images/icons/material/designSystem/PushPinFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/QuestionMark.js";
import "../../../../styles/assets/images/icons/material/designSystem/Receipt.js";
import "../../../../styles/assets/images/icons/material/designSystem/ReceiptFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Refresh.js";
import "../../../../styles/assets/images/icons/material/designSystem/RemoveCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/RemoveCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Replay.js";
import "../../../../styles/assets/images/icons/material/designSystem/Reply.js";
import "../../../../styles/assets/images/icons/material/designSystem/Restore.js";
import "../../../../styles/assets/images/icons/material/designSystem/Route.js";
import "../../../../styles/assets/images/icons/material/designSystem/Save.js";
import "../../../../styles/assets/images/icons/material/designSystem/SaveFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Schedule.js";
import "../../../../styles/assets/images/icons/material/designSystem/Search.js";
import "../../../../styles/assets/images/icons/material/designSystem/Security.js";
import "../../../../styles/assets/images/icons/material/designSystem/Settings.js";
import "../../../../styles/assets/images/icons/material/designSystem/SettingsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Shield.js";
import "../../../../styles/assets/images/icons/material/designSystem/ShieldFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Smartphone.js";
import "../../../../styles/assets/images/icons/material/designSystem/SmartphoneFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Square.js";
import "../../../../styles/assets/images/icons/material/designSystem/SquareFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/SwapHorizontalCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/SwapHorizontalCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/TableView.js";
import "../../../../styles/assets/images/icons/material/designSystem/Tune.js";
import "../../../../styles/assets/images/icons/material/designSystem/Undo.js";
import "../../../../styles/assets/images/icons/material/designSystem/Update.js";
import "../../../../styles/assets/images/icons/material/designSystem/Videocam.js";
import "../../../../styles/assets/images/icons/material/designSystem/VideocamFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ViewList.js";
import "../../../../styles/assets/images/icons/material/designSystem/ViewListFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Visibility.js";
import "../../../../styles/assets/images/icons/material/designSystem/VisibilityFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/VisibilityOffFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Warning.js";
import "../../../../styles/assets/images/icons/material/designSystem/WarningFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/WiFi.js";
import "../../../../styles/assets/images/icons/material/designSystem/WiFiOff.js";
import "../../../../styles/assets/images/icons/material/designSystem/Work.js";
import "../../../../styles/assets/images/icons/material/designSystem/WorkFilled.js";
import "../../../../styles/assets/images/icons/brands/GoogleG.js";
import { sass } from "../../../../sass/sass.js";
import { noOp } from "../../../../utils/noOp.js";
import FlashButton from "../../buttons/FlashButton/FlashButton.js";
import { FlashModalFooter, FlashModalTitle } from "./FlashModalUtils.js";
import { I as I18nextProvider } from "../../../../I18nextProvider-16dc4551.js";
import "../../../../axios-5f69b112.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "../../../../Transition-c07376a3.js";
import "../../../../index-2d889c01.js";
import "../../../../hooks/useInsights/useInsights.js";
import "../../../../hooks/useLogger/constants.js";
import "../../../../hooks/useLogger/useLogger.js";
import "../../../../hooks/useLogger/LoggerContext.js";
import "../../../../hooks/useLogger/types.js";
import "../../../../hooks/useInsights/InsightsContext.js";
import "../../../../hooks/useWindowSize/WindowSizeContext.js";
import "../../../../isObject-ec23ace2.js";
import "../../../../isSymbol-c6f5cd95.js";
import "../../../../i18n/translations/en.js";
import "../../../../i18n/translations/es.js";
import "../../../../i18nInstance-89725fcb.js";
import "../../info/FlashBadge/FlashBadge.js";
import "../../info/FlashSpinner/FlashSpinner.js";
import "../../buttons/FlashButtonGeneric.js";
import "../../../../Button-9f0631d3.js";
import "../../../../utils/invokeFn.js";
import "../../buttons/FlashButton/constants.js";
import "../../../../useTranslation-cf39c293.js";
import "../../../../keysIn-f10bd97a.js";
import "../../../../_arrayLikeKeys-44b287e6.js";
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$1(Constructor.prototype, protoProps), staticProps && _defineProperties$1(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, _setPrototypeOf$1(o, p);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function() {
    var Super = _getPrototypeOf$1(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else
      result = Super.apply(this, arguments);
    return _possibleConstructorReturn$1(this, result);
  };
}
function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(self);
}
function _assertThisInitialized$1(self) {
  if (self === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$1(o) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, _getPrototypeOf$1(o);
}
var propTypes$1 = {
  children: PropTypes.node.isRequired,
  node: PropTypes.any
}, Portal = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(Portal2, _React$Component);
  var _super = _createSuper$1(Portal2);
  function Portal2() {
    return _classCallCheck$1(this, Portal2), _super.apply(this, arguments);
  }
  return _createClass$1(Portal2, [{
    key: "componentWillUnmount",
    value: function() {
      this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null;
    }
  }, {
    key: "render",
    value: function() {
      return canUseDOM ? (!this.props.node && !this.defaultNode && (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode)), /* @__PURE__ */ ReactDOM__default.createPortal(this.props.children, this.props.node || this.defaultNode)) : null;
    }
  }]), Portal2;
}(React__default.Component);
Portal.propTypes = propTypes$1;
const Portal$1 = Portal;
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj[key] = value, obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else
      result = Super.apply(this, arguments);
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf(o) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, _getPrototypeOf(o);
}
function noop() {
}
var FadePropTypes = PropTypes.shape(Fade.propTypes), propTypes = {
  /** */
  autoFocus: PropTypes.bool,
  /** Add backdrop to modal */
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["static"])]),
  /** add custom classname to backdrop */
  backdropClassName: PropTypes.string,
  backdropTransition: FadePropTypes,
  /** Vertically center the modal */
  centered: PropTypes.bool,
  /** Add children for the modal to wrap */
  children: PropTypes.node,
  /** Add custom className for modal content */
  contentClassName: PropTypes.string,
  className: PropTypes.string,
  container: targetPropType,
  cssModule: PropTypes.object,
  external: PropTypes.node,
  /** Enable/Disable animation */
  fade: PropTypes.bool,
  /** Make the modal fullscreen */
  fullscreen: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["sm", "md", "lg", "xl"])]),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  /** The status of the modal, either open or close */
  isOpen: PropTypes.bool,
  /** Allow modal to be closed with escape key. */
  keyboard: PropTypes.bool,
  /** Identifies the element (or elements) that labels the current element. */
  labelledBy: PropTypes.string,
  modalClassName: PropTypes.string,
  modalTransition: FadePropTypes,
  /** Function to be triggered on close */
  onClosed: PropTypes.func,
  /** Function to be triggered on enter */
  onEnter: PropTypes.func,
  /** Function to be triggered on exit */
  onExit: PropTypes.func,
  /** Function to be triggered on open */
  onOpened: PropTypes.func,
  /** Returns focus to the element that triggered opening of the modal */
  returnFocusAfterClose: PropTypes.bool,
  /** Accessibility role */
  role: PropTypes.string,
  /** Make the modal scrollable */
  scrollable: PropTypes.bool,
  /** Two optional sizes `lg` and `sm` */
  size: PropTypes.string,
  /** Function to toggle modal visibility */
  toggle: PropTypes.func,
  trapFocus: PropTypes.bool,
  /** Unmounts the modal when modal is closed */
  unmountOnClose: PropTypes.bool,
  wrapClassName: PropTypes.string,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}, propsToOmit = Object.keys(propTypes), defaultProps = {
  isOpen: !1,
  autoFocus: !0,
  centered: !1,
  scrollable: !1,
  role: "dialog",
  backdrop: !0,
  keyboard: !0,
  zIndex: 1050,
  fade: !0,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: !0,
    timeout: TransitionTimeouts.Fade
    // uses standard fade transition
  },
  unmountOnClose: !0,
  returnFocusAfterClose: !0,
  container: "body",
  trapFocus: !1
}, Modal = /* @__PURE__ */ function(_React$Component) {
  _inherits(Modal2, _React$Component);
  var _super = _createSuper(Modal2);
  function Modal2(props) {
    var _this;
    return _classCallCheck(this, Modal2), _this = _super.call(this, props), _this._element = null, _this._originalBodyPadding = null, _this.getFocusableChildren = _this.getFocusableChildren.bind(_assertThisInitialized(_this)), _this.handleBackdropClick = _this.handleBackdropClick.bind(_assertThisInitialized(_this)), _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind(_assertThisInitialized(_this)), _this.handleEscape = _this.handleEscape.bind(_assertThisInitialized(_this)), _this.handleStaticBackdropAnimation = _this.handleStaticBackdropAnimation.bind(_assertThisInitialized(_this)), _this.handleTab = _this.handleTab.bind(_assertThisInitialized(_this)), _this.onOpened = _this.onOpened.bind(_assertThisInitialized(_this)), _this.onClosed = _this.onClosed.bind(_assertThisInitialized(_this)), _this.manageFocusAfterClose = _this.manageFocusAfterClose.bind(_assertThisInitialized(_this)), _this.clearBackdropAnimationTimeout = _this.clearBackdropAnimationTimeout.bind(_assertThisInitialized(_this)), _this.trapFocus = _this.trapFocus.bind(_assertThisInitialized(_this)), _this.state = {
      isOpen: !1,
      showStaticBackdropAnimation: !1
    }, _this;
  }
  return _createClass(Modal2, [{
    key: "componentDidMount",
    value: function() {
      var _this$props = this.props, isOpen = _this$props.isOpen, autoFocus = _this$props.autoFocus, onEnter = _this$props.onEnter;
      isOpen && (this.init(), this.setState({
        isOpen: !0
      }), autoFocus && this.setFocus()), onEnter && onEnter(), document.addEventListener("focus", this.trapFocus, !0), this._isMounted = !0;
    }
  }, {
    key: "componentDidUpdate",
    value: function(prevProps, prevState) {
      if (this.props.isOpen && !prevProps.isOpen) {
        this.init(), this.setState({
          isOpen: !0
        });
        return;
      }
      this.props.autoFocus && this.state.isOpen && !prevState.isOpen && this.setFocus(), this._element && prevProps.zIndex !== this.props.zIndex && (this._element.style.zIndex = this.props.zIndex);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearBackdropAnimationTimeout(), this.props.onExit && this.props.onExit(), this._element && (this.destroy(), (this.props.isOpen || this.state.isOpen) && this.close()), document.removeEventListener("focus", this.trapFocus, !0), this._isMounted = !1;
    }
    // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
  }, {
    key: "handleBackdropClick",
    value: function(e) {
      if (e.target === this._mouseDownElement) {
        e.stopPropagation();
        var backdrop = this._dialog ? this._dialog.parentNode : null;
        if (backdrop && e.target === backdrop && this.props.backdrop === "static" && this.handleStaticBackdropAnimation(), !this.props.isOpen || this.props.backdrop !== !0)
          return;
        backdrop && e.target === backdrop && this.props.toggle && this.props.toggle(e);
      }
    }
  }, {
    key: "handleTab",
    value: function(e) {
      if (e.which === 9 && !(this.modalIndex < Modal2.openCount - 1)) {
        var focusableChildren = this.getFocusableChildren(), totalFocusable = focusableChildren.length;
        if (totalFocusable !== 0) {
          for (var currentFocus = this.getFocusedChild(), focusedIndex = 0, i = 0; i < totalFocusable; i += 1)
            if (focusableChildren[i] === currentFocus) {
              focusedIndex = i;
              break;
            }
          e.shiftKey && focusedIndex === 0 ? (e.preventDefault(), focusableChildren[totalFocusable - 1].focus()) : !e.shiftKey && focusedIndex === totalFocusable - 1 && (e.preventDefault(), focusableChildren[0].focus());
        }
      }
    }
  }, {
    key: "handleBackdropMouseDown",
    value: function(e) {
      this._mouseDownElement = e.target;
    }
  }, {
    key: "handleEscape",
    value: function(e) {
      this.props.isOpen && e.keyCode === keyCodes.esc && this.props.toggle && (this.props.keyboard ? (e.preventDefault(), e.stopPropagation(), this.props.toggle(e)) : this.props.backdrop === "static" && (e.preventDefault(), e.stopPropagation(), this.handleStaticBackdropAnimation()));
    }
  }, {
    key: "handleStaticBackdropAnimation",
    value: function() {
      var _this2 = this;
      this.clearBackdropAnimationTimeout(), this.setState({
        showStaticBackdropAnimation: !0
      }), this._backdropAnimationTimeout = setTimeout(function() {
        _this2.setState({
          showStaticBackdropAnimation: !1
        });
      }, 100);
    }
  }, {
    key: "onOpened",
    value: function(node, isAppearing) {
      this.props.onOpened(), (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    }
  }, {
    key: "onClosed",
    value: function(node) {
      var unmountOnClose = this.props.unmountOnClose;
      this.props.onClosed(), (this.props.modalTransition.onExited || noop)(node), unmountOnClose && this.destroy(), this.close(), this._isMounted && this.setState({
        isOpen: !1
      });
    }
  }, {
    key: "setFocus",
    value: function() {
      this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus == "function" && this._dialog.parentNode.focus();
    }
  }, {
    key: "getFocusableChildren",
    value: function() {
      return this._element.querySelectorAll(focusableElements.join(", "));
    }
  }, {
    key: "getFocusedChild",
    value: function() {
      var currentFocus, focusableChildren = this.getFocusableChildren();
      try {
        currentFocus = document.activeElement;
      } catch {
        currentFocus = focusableChildren[0];
      }
      return currentFocus;
    }
  }, {
    key: "trapFocus",
    value: function(ev) {
      if (this.props.trapFocus && this._element && !(this._dialog && this._dialog.parentNode === ev.target) && !(this.modalIndex < Modal2.openCount - 1)) {
        for (var children = this.getFocusableChildren(), i = 0; i < children.length; i += 1)
          if (children[i] === ev.target)
            return;
        children.length > 0 && (ev.preventDefault(), ev.stopPropagation(), children[0].focus());
      }
    }
  }, {
    key: "init",
    value: function() {
      try {
        this._triggeringElement = document.activeElement;
      } catch {
        this._triggeringElement = null;
      }
      this._element || (this._element = document.createElement("div"), this._element.setAttribute("tabindex", "-1"), this._element.style.position = "relative", this._element.style.zIndex = this.props.zIndex, this._mountContainer = getTarget(this.props.container), this._mountContainer.appendChild(this._element)), this._originalBodyPadding = getOriginalBodyPadding(), Modal2.openCount < 1 && (Modal2.originalBodyOverflow = window.getComputedStyle(document.body).overflow), conditionallyUpdateScrollbar(), Modal2.openCount === 0 && (document.body.className = classNames(document.body.className, mapToCssModules("modal-open", this.props.cssModule)), document.body.style.overflow = "hidden"), this.modalIndex = Modal2.openCount, Modal2.openCount += 1;
    }
  }, {
    key: "destroy",
    value: function() {
      this._element && (this._mountContainer.removeChild(this._element), this._element = null), this.manageFocusAfterClose();
    }
  }, {
    key: "manageFocusAfterClose",
    value: function() {
      if (this._triggeringElement) {
        var returnFocusAfterClose = this.props.returnFocusAfterClose;
        this._triggeringElement.focus && returnFocusAfterClose && this._triggeringElement.focus(), this._triggeringElement = null;
      }
    }
  }, {
    key: "close",
    value: function() {
      if (Modal2.openCount <= 1) {
        var modalOpenClassName = mapToCssModules("modal-open", this.props.cssModule), modalOpenClassNameRegex = new RegExp("(^| )".concat(modalOpenClassName, "( |$)"));
        document.body.className = document.body.className.replace(modalOpenClassNameRegex, " ").trim(), document.body.style.overflow = Modal2.originalBodyOverflow;
      }
      this.manageFocusAfterClose(), Modal2.openCount = Math.max(0, Modal2.openCount - 1), setScrollbarWidth(this._originalBodyPadding);
    }
  }, {
    key: "clearBackdropAnimationTimeout",
    value: function() {
      this._backdropAnimationTimeout && (clearTimeout(this._backdropAnimationTimeout), this._backdropAnimationTimeout = void 0);
    }
  }, {
    key: "renderModalDialog",
    value: function() {
      var _classNames, _this3 = this, attributes = omit(this.props, propsToOmit), dialogBaseClass = "modal-dialog";
      return /* @__PURE__ */ React__default.createElement("div", _extends({}, attributes, {
        className: mapToCssModules(classNames(dialogBaseClass, this.props.className, (_classNames = {}, _defineProperty(_classNames, "modal-".concat(this.props.size), this.props.size), _defineProperty(_classNames, "".concat(dialogBaseClass, "-centered"), this.props.centered), _defineProperty(_classNames, "".concat(dialogBaseClass, "-scrollable"), this.props.scrollable), _defineProperty(_classNames, "modal-fullscreen", this.props.fullscreen === !0), _defineProperty(_classNames, "modal-fullscreen-".concat(this.props.fullscreen, "-down"), typeof this.props.fullscreen == "string"), _classNames)), this.props.cssModule),
        role: "document",
        ref: function(c) {
          _this3._dialog = c;
        }
      }), /* @__PURE__ */ React__default.createElement("div", {
        className: mapToCssModules(classNames("modal-content", this.props.contentClassName), this.props.cssModule)
      }, this.props.children));
    }
  }, {
    key: "render",
    value: function() {
      var unmountOnClose = this.props.unmountOnClose;
      if (this._element && (this.state.isOpen || !unmountOnClose)) {
        var isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
        this._element.style.display = isModalHidden ? "none" : "block";
        var _this$props2 = this.props, wrapClassName = _this$props2.wrapClassName, modalClassName = _this$props2.modalClassName, backdropClassName = _this$props2.backdropClassName, cssModule = _this$props2.cssModule, isOpen = _this$props2.isOpen, backdrop = _this$props2.backdrop, role = _this$props2.role, labelledBy = _this$props2.labelledBy, external = _this$props2.external, innerRef = _this$props2.innerRef, modalAttributes = {
          onClick: this.handleBackdropClick,
          onMouseDown: this.handleBackdropMouseDown,
          onKeyUp: this.handleEscape,
          onKeyDown: this.handleTab,
          style: {
            display: "block"
          },
          "aria-labelledby": labelledBy,
          "aria-modal": !0,
          role,
          tabIndex: "-1"
        }, hasTransition = this.props.fade, modalTransition = _objectSpread(_objectSpread(_objectSpread({}, Fade.defaultProps), this.props.modalTransition), {}, {
          baseClass: hasTransition ? this.props.modalTransition.baseClass : "",
          timeout: hasTransition ? this.props.modalTransition.timeout : 0
        }), backdropTransition = _objectSpread(_objectSpread(_objectSpread({}, Fade.defaultProps), this.props.backdropTransition), {}, {
          baseClass: hasTransition ? this.props.backdropTransition.baseClass : "",
          timeout: hasTransition ? this.props.backdropTransition.timeout : 0
        }), Backdrop = backdrop && (hasTransition ? /* @__PURE__ */ React__default.createElement(Fade, _extends({}, backdropTransition, {
          in: isOpen && !!backdrop,
          cssModule,
          className: mapToCssModules(classNames("modal-backdrop", backdropClassName), cssModule)
        })) : /* @__PURE__ */ React__default.createElement("div", {
          className: mapToCssModules(classNames("modal-backdrop", "show", backdropClassName), cssModule)
        }));
        return /* @__PURE__ */ React__default.createElement(Portal$1, {
          node: this._element
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: mapToCssModules(wrapClassName)
        }, /* @__PURE__ */ React__default.createElement(Fade, _extends({}, modalAttributes, modalTransition, {
          in: isOpen,
          onEntered: this.onOpened,
          onExited: this.onClosed,
          cssModule,
          className: mapToCssModules(classNames("modal", modalClassName, this.state.showStaticBackdropAnimation && "modal-static"), cssModule),
          innerRef
        }), external, this.renderModalDialog()), Backdrop));
      }
      return null;
    }
  }]), Modal2;
}(React__default.Component);
Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.openCount = 0;
Modal.originalBodyOverflow = null;
const Modal$1 = Modal;
function FlashModal(props) {
  const { CustomFooter, ...propsWithoutCustomFooter } = props, {
    modalId,
    modalProps = {},
    isOpen,
    toggle,
    close,
    onShow,
    onHide,
    onClose = noOp,
    children,
    dismiss,
    confirm,
    Title,
    hideHeader,
    hideFooter,
    bodyClassName,
    modalBodyRef,
    analytics
  } = propsWithoutCustomFooter, { scrollable = !0 } = modalProps, { windowIsMobile, windowHeight } = useWindowSize(), [headerHeight, setHeaderHeight] = useState(0), headerRef = useCallback((node) => {
    node && setHeaderHeight(node.getBoundingClientRect().height);
  }, []), [footerHeight, setFooterHeight] = useState(0), footerRef = useCallback((node) => {
    node && setFooterHeight(node.getBoundingClientRect().height);
  }, []), [bodyHeight, setBodyHeight] = useState(0), bodyRef = useCallback((node) => {
    node && setBodyHeight(node.getBoundingClientRect().height);
  }, []), isScrollingContent = useMemo(() => {
    const modalYMargin = 1.75 * sass.spacing.bootstrap.spacer + 1, spacerHeight = windowIsMobile ? modalYMargin : modalYMargin * 2, modalHeight = headerHeight + bodyHeight + footerHeight + spacerHeight;
    return windowHeight - modalHeight < 0;
  }, [windowIsMobile, windowHeight, headerHeight, bodyHeight, footerHeight]), { impressionRef } = useInsightsImpression(
    analyticsEventForImpression(analytics, ObjectProperties.MODAL),
    analytics == null ? void 0 : analytics.impressionOptions
  );
  return /* @__PURE__ */ jsxs(
    Modal$1,
    {
      id: `${modalId}-modal`,
      "data-testid": `${modalId}-modal`,
      isOpen,
      toggle,
      wrapClassName: COMMON_CLASSNAME,
      className: classNames("flash-modal", modalProps.className),
      onClosed: onHide,
      onOpened: onShow,
      scrollable,
      children: [
        /* @__PURE__ */ jsx("div", { ref: impressionRef }),
        /* @__PURE__ */ jsxs(I18nextProvider, { i18n, children: [
          !hideHeader && /* @__PURE__ */ jsx("div", { ref: headerRef, className: classNames("modal-header d-block pb-0", { "shadow-sm": isScrollingContent }), children: /* @__PURE__ */ jsx(FlashModalHeader, { modalId, Title, close, onClose }) }),
          /* @__PURE__ */ jsx("div", { id: `${modalId}-modal-body`, ref: bodyRef, className: classNames("modal-body", bodyClassName), children: /* @__PURE__ */ jsx("div", { ref: modalBodyRef, children }) }),
          !hideFooter && /* @__PURE__ */ jsx("div", { ref: footerRef, className: classNames("modal-footer", { "shadow-sm": isScrollingContent }), children: CustomFooter ? /* @__PURE__ */ jsx(CustomFooter, { ...propsWithoutCustomFooter }) : /* @__PURE__ */ jsx(FlashModalFooter, { modalId, close, dismiss, confirm }) })
        ] })
      ]
    }
  );
}
function FlashModalHeader(props) {
  const { modalId, Title, close, onClose } = props;
  return /* @__PURE__ */ jsxs("div", { className: "w-100 d-flex justify-content-between", children: [
    /* @__PURE__ */ jsx("div", { className: "order-last ms-4 ms-sm-0 text-end", children: /* @__PURE__ */ jsx(
      FlashButton,
      {
        id: `${modalId}-close-btn`,
        onClick: (event) => {
          onClose(event), close(event);
        },
        color: "icon_only_default",
        LeadingIcon: ForwardRef,
        removePadding: !0,
        className: "m-n2",
        iconFontSize: sass.typography.flash.semantic.font.heading.xl.size
      }
    ) }),
    /* @__PURE__ */ jsx("div", { className: "mb-2", children: typeof Title == "string" ? /* @__PURE__ */ jsx(FlashModalTitle, { title: Title }) : Title })
  ] });
}
export {
  FlashModal as default
};
//# sourceMappingURL=FlashModal.js.map
